import React, { useEffect, useState } from "react";
import s from "./slider.module.css";
import { SliderData } from "./sliderData";

const ImageSlider = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const length = slides.length;
  const nextSlide = () => {
    setCurrentSlide(currentSlide === length - 1 ? 0 : currentSlide + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? length - 1 : currentSlide - 1);
  };
  const slideIn = {
    opacity: "0",
    transitionDuration: "1s ease",
  };
  const slideActive = {
    opacity: "1",
    transitionDuration: "1s",
    transition: "scale(1.07)",
  };

  useEffect(() => {
    let i = currentSlide;
    const timerId = setInterval(() => {
      ++i;
      if (i >= SliderData.length) i = 0;
      setCurrentSlide(i);
    }, 3000);

    return () => clearInterval(timerId);
  }, [currentSlide]);

  if (!Array.isArray(slides) || slides.length <= 0) return null;
  return (
    <div className={s.slider}>
      <div className={s.leftArrow} onClick={prevSlide}></div>
      <div className={s.rightArrow} onClick={nextSlide}></div>
      {SliderData.map((slide, index) => {
        return (
          <div
            style={index === currentSlide ? slideActive : slideIn}
            key={index}
          >
            {index === currentSlide && (
              <img src={slide.image} alt="slider" className={s.sliderImage} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ImageSlider;
